@if (newTemplate) {
  <div class="new-template">
    <risk-card [newCard]="true">
      <div card-header class="card-header">
        <div class="header-content">
          <div class="header-top">
            <div class="header-left">
              <div class="header-title">
                <div class="header-year" data-cy="lifePolicyTitle">
                  Life ({{ policy?.namedInsured | titleCase }})
                </div>
                <!-- <div class="header-name">{{ vehicle.make }} {{ vehicle.model }}</div> -->
              </div>
            </div>
            <div class="pilet">
              <div class="pilet-text icon-complete" data-cy="lifePolicyActiveTitle">Active</div>
            </div>
          </div>
        </div>
      </div>
      <div card-body class="card-body">
        <div class="grid-container">
          <!-- Row 1 -->
          <div class="row">
            <div class="grid-cell">
              <div class="label" data-cy="lifePolicyNumberTitle">Policy Number</div>
              <div class="value" data-cy="lifePolicyNumber">{{ policy | prettyPolicyNum }}</div>
            </div>
            <div class="grid-cell">
              <div class="label" data-cy="lifePolicyEffectiveDateTitle">Effective Date</div>
              <div class="value" data-cy="lifePolicyEffectiveDate">
                {{ policy.periodStartDate | date: 'MMM d, y' }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="grid-cell">
              <div class="label" data-cy="lifeBasePlanAmount">Base Plan Amount</div>
              <div class="amount" data-cy="lifePolicyCoverageAmount">
                {{ policy?.coverageAmount | currencyUSD: true }}
              </div>
            </div>
            <div class="grid-cell">
              <div class="label" data-cy="lifePolicyTermTitle">Term</div>
              <div class="value" data-cy="lifePolicyTerm">
                {{ policy.term }}
              </div>
            </div>
          </div>
        </div>
        <div class="image-container">
          <img src="/assets/images/life-policy.svg" />
        </div>
      </div>
      <div class="card-footer" card-footer>
        <div class="text-and-button" data-cy="makePayment">
          Make a Payment
          <a data-cy="get-documents-link" href="tel:+18664248002">
            <span class="icon icon-call with-gradient"></span>
            <span data-cy="makePaymentNumber">1-866-424-8002</span>
          </a>
        </div>
        <div class="text-and-button" data-cy="requestPolicyUpdate">
          Request a Policy Update
          <a data-cy="get-documents-link" href="tel:+18445146226">
            <span class="icon icon-call with-gradient"></span>
            <span data-cy="requestPolicyUpdateNumber">1-844-514-6226</span>
          </a>
        </div>
      </div>
    </risk-card>
  </div>
} @else {
  <risk-card [newCard]="false">
    <div header>
      <div class="column twelve md-six">
        <div class="double-icon">
          <span
            role="img"
            dsTabFocus
            [attr.aria-label]="policy.policyTypeDisplayName + ' Policy'"
            class="icon xl-inline icon-life"
          ></span>
        </div>
        @if (policy.namedInsured) {
          <p class="heading" data-cy="lifePolicyNamedInsured">
            {{ policy?.namedInsured | titleCase }}
          </p>
        }
        @if (policy.policyNumber) {
          <p class="heading-policy-vin" data-cy="lifePolicyPrettyNumber">
            Policy: {{ policy | prettyPolicyNum }}
          </p>
        }
      </div>
      <div class="column twelve md-six">
        @if (policy.periodStartDate) {
          <p class="heading-policy-vin pad-bottom-10" data-cy="lifePolicyEffectiveDate">
            Effective Date: {{ policy?.periodStartDate | dateFormat }}
          </p>
        }
        @if (policy.coverageAmount) {
          <p class="heading-policy-vin" data-cy="lifePolicyCoverageAmount">
            {{ policy?.coverageAmount | currencyUSD: true }} Base Plan Amount
          </p>
        }
      </div>
    </div>
    <div>
      <p dsContent [contentPath]="'policy.lifeCardInfo'" data-cy="lifePolicyCardInfo"></p>
      <p
        dsContent
        [contentPath]="'policy.lifeCardInfoContact'"
        [options]="{ phoneNumber: phoneNumber }"
        data-cy="lifePolicyCardInfoContact"
      ></p>
    </div>
  </risk-card>
}
